import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { AppSettings } from "../../app-settings";

@Component({
  selector: "app-journey-view-learning-level",
  templateUrl: "./journey-view-learning-level.component.html",
  styleUrls: ["./journey-view-learning-level.component.css"],
})
export class JourneyViewLearningLevelComponent implements OnInit {
  expandIconAssetURL: string = AppSettings.cdnUrl + "assets/images/expand.png";
  collapseIconAssetURL: string = AppSettings.cdnUrl + "assets/images/collapse_level.png";

  @Input() level = {
    grade: "",
    levelName: "",
    collapsed: true,
    activityDetailsCollapsed: true,
    completedActivities: 0,
    totalActivities: 0,
    gradeBackground: "",
    activityListInfo: [],
    gradeClass: "",
    id: null,
  };

  @Input() index;

  @Input() paceEnabled;

  @Output() closeSidebarParent = new EventEmitter<any>();

  @Input() activityId;


  grade = {
    A: "Grade A",
    B: "Grade B",
    'A-': "Grade A-",
    'B-': "Grade B-",
    C: "Grade C",
    NR: "NR",
  };

  constructor(
  ) {}

  ngOnInit() {
    this.level.collapsed = this.level['isRecentModule'] == 'YES' ? false : true;
  }

  toggleLevelDetailsView() {
    this.level.collapsed = !this.level.collapsed;
  }

  calWidthOfProgressBar(completedActivities, totalActivities) {
    return (completedActivities / totalActivities) * 100;
  }

  closeSidebar(state){
    this.closeSidebarParent.emit(state);
  }
}
